"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _WrapperQuestion = _interopRequireDefault(require("./WrapperQuestion"));

var _WrapperPopular = _interopRequireDefault(require("./WrapperPopular"));

var _WrapperButtons = _interopRequireDefault(require("./WrapperButtons"));

var _WrapperTips = _interopRequireDefault(require("./WrapperTips"));

var _WrapperAvatar = _interopRequireDefault(require("./WrapperAvatar"));

var _WrapperPoints = _interopRequireDefault(require("./WrapperPoints"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem};\n"])));

var StyledLeft = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 1px;\n"])));

var StyledRight = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 0 0 40%;\n\n  @media (min-width: ", ") {\n    flex: 0 0 40%;\n  }\n"])), function (props) {
  return props.theme.screenWidthXs;
});

var StyledQuestionStat = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 0.825rem;\n  font-weight: 600;\n  line-height: 1.45;\n  padding-right: 1rem;\n  color: ", ";\n  margin-bottom: 1rem;\n"])), function (p) {
  return p.theme.colorLabel;
});

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      betbarParent = _ref.betbarParent,
      updatePicks = _ref.updatePicks,
      isLocked = _ref.isLocked,
      hidePopularPick = _ref.hidePopularPick,
      data = _ref.data,
      availablePoints = _ref.availablePoints,
      myAnswerId = _ref.myAnswerId,
      correctAnswerId = _ref.correctAnswerId,
      popularSelectionString = _ref.popularSelectionString,
      tips = _ref.tips,
      showIcon = _ref.showIcon,
      id = _ref.id,
      options = _ref.options,
      label = _ref.label,
      subtitle = _ref.subtitle,
      tipsterString = _ref.tipsterString,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      hasQuestionStatBelowQuestion = _ref.hasQuestionStatBelowQuestion;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLeft, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrapperQuestion.default, {
          hasQuestionStatBelowQuestion: hasQuestionStatBelowQuestion,
          question: label,
          questionStat: subtitle,
          entity: data
        })
      }), data !== null && data !== void 0 && data.avatarImg || data !== null && data !== void 0 && data.avatar || data !== null && data !== void 0 && data.logo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRight, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrapperAvatar.default, {
          avatar: (data === null || data === void 0 ? void 0 : data.avatarImg) || (data === null || data === void 0 ? void 0 : data.avatar) || (data === null || data === void 0 ? void 0 : data.logo)
        })
      }) : null]
    }), hasQuestionStatBelowQuestion && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledQuestionStat, {
      children: subtitle
    }), !hidePopularPick && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      style: {
        marginBottom: "1rem"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLeft, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrapperPopular.default, {
          popularSelection: popularSelectionString
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRight, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrapperPoints.default, {
          translations: translations,
          correctAnswerId: correctAnswerId,
          myAnswerId: myAnswerId,
          isLocked: isLocked,
          showIcon: showIcon,
          availablePoints: availablePoints
        })
      })]
    }), tips && tips[0] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrapperTips.default, {
      tip: tips[0],
      tipsterString: tipsterString
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrapperButtons.default, {
      translations: translations,
      betbarParent: betbarParent,
      correctAnswerId: correctAnswerId,
      myAnswerId: myAnswerId,
      isLocked: isLocked,
      showIcon: showIcon,
      questionId: id,
      updatePicks: updatePicks,
      questionOptions: options
    })]
  });
};

var _default = Wrapper;
exports.default = _default;